import { render, staticRenderFns } from "./ViewStudentModal.vue?vue&type=template&id=10d7e380&scoped=true&"
import script from "./ViewStudentModal.vue?vue&type=script&lang=js&"
export * from "./ViewStudentModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewStudentModal.vue?vue&type=style&index=0&id=10d7e380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d7e380",
  null
  
)

export default component.exports